import * as React from 'react';
import Dialog from 'rc-dialog';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
import { ConfigContext } from '../config-provider';
import Button from '../button';
import { canUseDocElement } from '../_util/styleChecker';
import { getTransitionName } from '../_util/motion';
import classNames from 'classnames';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import { getModalLocale } from './locale';
let mousePosition;
// 100ms 内发生过点击事件，则从点击位置动画展示
const getClickPosition = (e) => {
    mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    setTimeout(() => {
        mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if (canUseDocElement()) {
    document.documentElement.addEventListener('click', getClickPosition, true);
}
// type SizeType = 'small' | 'normal' | 'large' | 'extraLarge';
var SizeType;
(function (SizeType) {
    SizeType["small"] = "sm";
    SizeType["normal"] = "md";
    SizeType["large"] = "lg";
    SizeType["extraLarge"] = "xl";
})(SizeType || (SizeType = {}));
;
const Modal = props => {
    const { getPopupContainer, getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('modal', props.prefixCls);
    const rootPrefixCls = getPrefixCls();
    const handleCancel = (e) => {
        const { onCancel } = props;
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
    };
    const handleOk = (e) => {
        const { onOk } = props;
        onOk === null || onOk === void 0 ? void 0 : onOk(e);
    };
    const renderFooter = (locale) => {
        const { okText, cancelText, okButtonProps, cancelButtonProps } = props;
        const confirmLoading = props.confirmLoading === undefined ? false : props.confirmLoading;
        return (<>
                <Button onClick={handleCancel} type="default" {...cancelButtonProps}>
                    {cancelText || locale.cancelText}
                </Button>
                <Button onClick={handleOk} loading={confirmLoading} type="primary" {...okButtonProps}>
                    {okText || locale.okText}
                </Button>
            </>);
    };
    const defaultFooter = (<LocaleReceiver componentName="Modal" defaultLocale={getModalLocale()}>
            {renderFooter}
        </LocaleReceiver>);
    const { className, footer, getContainer, closeIcon } = props;
    const visible = props.visible === undefined ? false : props.visible;
    const size = props.size === undefined ? 'small' : props.size;
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const dialogFooter = footer === undefined ? defaultFooter : footer;
    const dialogGetContainer = getContainer !== null && getContainer !== void 0 ? getContainer : getPopupContainer;
    const dialogCloseIcon = (<span className={`${prefixCls}-close-x`}>
            {closeIcon === undefined ? <OutlinedClose className={`${prefixCls}-close-icon`}/> : closeIcon}
        </span>);
    return (<Dialog {...props} 
    // TODO: Ignore this type error for now, otherwise need to upgrade rc-dialog.
    width={props.width} className={classNames(className, `${prefixCls}-${SizeType[size]}`)} getContainer={dialogGetContainer} prefixCls={prefixCls} visible={visible} maskClosable={maskClosable} footer={dialogFooter} mousePosition={mousePosition} onClose={handleCancel} closeIcon={dialogCloseIcon} transitionName={getTransitionName(rootPrefixCls, 'fade')} maskTransitionName={getTransitionName(rootPrefixCls, 'fade')}/>);
};
/*
Modal.defaultProps = {
    size: 'small',
    visible: false,
    confirmLoading: false,
    maskClosable: false,
};
*/
export default Modal;
